export const server = "https://bureautiqe-bismos.vercel.app/api/v2";
export const backend_url = "https://bureautiqe-bismos.vercel.app/";
